module.exports = __webpack_public_path__ + "img/r203.9475d691.jpg";